export default __webpack_public_path__ + "static/media/money-bag.687c12c3.png";